import {
  SnapshotsSortBy,
  SnapshotsTableColumnField,
  SnapshotsSortField,
} from "@pages/project-details/project-snapshots/snapshots-table-types";
import { SortItem, SortOption } from "@custom-types/sort-types";

/** The labels for the columns in the snapshots table */
export const SNAPSHOTS_TABLE_COLUMN_LABELS: Record<
  SnapshotsTableColumnField,
  string
> = {
  name: "Snapshot Name",
  accessLevel: "Access Level",
  created: "Created",
  options: "Options",
};

/** Default snapshots sort by option */
export const DEFAULT_SNAPSHOTS_SORT_BY: SnapshotsSortBy = "name_ascending";

/** Available snapshots sort field options */
export const SNAPSHOTS_SORT_OPTIONS: Record<
  SnapshotsSortField,
  SortOption<SnapshotsSortField>
> = {
  name: {
    field: "name",
    label: SNAPSHOTS_TABLE_COLUMN_LABELS.name,
  },
  accessLevel: {
    field: "accessLevel",
    label: SNAPSHOTS_TABLE_COLUMN_LABELS.accessLevel,
  },
  created: {
    field: "created",
    label: SNAPSHOTS_TABLE_COLUMN_LABELS.created,
  },
};

/** Map of the sort by options to the SortItem format */
export const SNAPSHOTS_SORT_BY_MAP: Record<
  SnapshotsSortBy,
  SortItem<SnapshotsSortField>
> = {
  ["name_ascending"]: {
    field: "name",
    sort: "asc",
  },
  ["name_descending"]: {
    field: "name",
    sort: "desc",
  },
  ["created_ascending"]: {
    field: "created",
    sort: "asc",
  },
  ["created_descending"]: {
    field: "created",
    sort: "desc",
  },
  ["accessLevel_ascending"]: {
    field: "accessLevel",
    sort: "asc",
  },
  ["accessLevel_descending"]: {
    field: "accessLevel",
    sort: "desc",
  },
};
